import React from "react";
import styled from "styled-components/macro";
import { Grid, Typography, MenuItem } from "@mui/material";

import { ComponentHeader, Label, Paper, TextField } from "../../../components";

let siteColors = JSON.parse(sessionStorage.getItem("siteColors"));

const MainHeading = styled(Typography)`
  font-weight: 600;
  font-size: 20px;
  line-height: 33px;
  color: ${siteColors?.primary};
`;

const Menu = styled(MenuItem)`
  font-weight: 400;
  font-size: 18px;
  line-height: 27px;
`;

export default function FormOne({ formikProps, editState, brands }) {
  return (
    <React.Fragment>
      <Paper gridSpacing={6}>
        <Grid item xs={12}>
          <ComponentHeader title={"Brand Affiliation"} />
        </Grid>

        <Grid item xs={6}>
          <Label title="Brand Name" />

          <TextField
            select
            formikProps={formikProps}
            name="brandID"
            disabled={!editState}
            sx={{
              "& .MuiSvgIcon-root": {
                display: !editState && "none",
              },
            }}
            SelectProps={{
              displayEmpty: true,
            }}
          >
            <Menu value="" disabled>
              Select Brand
            </Menu>
            {brands.map((brand) => (
              <Menu key={brand.brand_id} value={brand.brand_id}>
                {brand.brand_name}
              </Menu>
            ))}
          </TextField>
        </Grid>
      </Paper>

      <Paper gridSpacing={6}>
        <Grid item xs={12}>
          <ComponentHeader title={"Add New User"} />
        </Grid>

        <Grid item xs={6}>
          <Label title="Given Name" />

          <TextField
            disabled={!editState}
            name="givenName"
            placeholder="Given Name"
            formikProps={formikProps}
            inputProps={{ "aria-label": "Without label" }}
          />
        </Grid>

        <Grid item xs={6}>
          <Label title="Family Name" />

          <TextField
            disabled={!editState}
            name="familyName"
            placeholder="Family Name"
            formikProps={formikProps}
            inputProps={{ "aria-label": "Without label" }}
          />
        </Grid>

        <Grid item xs={6}>
          <Label title="Email" />

          <TextField
            disabled={!editState}
            name="email"
            placeholder="Email"
            formikProps={formikProps}
          />
        </Grid>

        <Grid item xs={6}>
          <Label title="Password" />

          <TextField
            type="password"
            disabled={!editState}
            name="password"
            placeholder="********"
            formikProps={formikProps}
            value={"********"}
          />
        </Grid>
      </Paper>
    </React.Fragment>
  );
}
